
class HXFormFieldCheckbox extends HXFormField {

    constructor(inputName,formName) {
        super(inputName,formName);
    }

    /**
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        //keine Validation noetig
        super._validateFieldInit();
        return this.validationPassed;
    }

    /**
     * @param {boolean} optional
     */
    setOptional(optional) {
        //Optional nicht relevant
    }

    /**
     * @returns {boolean} optional (immer true, da keine Mussfeldpruefung moeglich
     */
    getOptional() {
        return true; //Optional nicht relevant
    }

    /**
     * @param checked
     */
    setChecked(checked) {
        return this.inputObj.checked = checked;
    }

    /**
     * @returns {boolean} checked
     */
    getChecked() {
        return this.inputObj.checked;
    }

    displayInit() {

    }
}